module.exports = __webpack_public_path__ + "img/zs18.f7644bb1.jpg";